import { styled } from "@mui/material";
import BarekamText from "../../../components/text";
import { StandardDialog } from "../../../components/dialogs/standard-dialog/standard-dialog";

export const BarekamTextWrapper = styled(BarekamText)`
  font-size: 40px !important;
  text-align: center !important;
  padding-bottom: 60px;
  color: #ffffff;

  @media screen and (max-width: 768px) {
    font-size: 30px !important;
    padding-bottom: 30px;
  }
`;

export const WholSaleDialog = styled(StandardDialog)`
  
.MuiDialog-paper {
  max-width: 640px;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    margin: 66px 0 0;
  }

  .modal-close {
    width: 150px;
    align-self: flex-end;
    margin: 10px;
  }
}
`;

export const RequestFormContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;

  .type-container {
    div {
      button {
        width: 50% !important;
      }
    }
  }
`;

export const DimensionsContainer = styled('div')`
  display: flex;
  gap: 10px;
`;